import TextCell from 'components/TextCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function CreatedByCell({ rowData: { createdBy } }: CellProps) {
  return <TextCell text={createdBy?.name} />;
}
